import React, { useState } from 'react';
import { AdminLayout } from '../../components/layout/AdminLayout';
import { useTenant } from '../../lib/tenant-context';
import { useAvailableRewards, useRedeemReward, useCustomerLookup } from '../../lib/loyalty-hooks';
import { Card } from '../../components/ui/Card';
import { Input } from '../../components/ui/Input';
import { Button } from '../../components/ui/Button';
import { Search, Gift, CheckCircle2 } from 'lucide-react';
export function LoyaltyRedemptionPage() {
  const {
    restaurant,
    role,
    signOut
  } = useTenant();
  const [phoneSearch, setPhoneSearch] = useState('');
  const [activePhone, setActivePhone] = useState('');
  const {
    customer,
    loading: customerLoading
  } = useCustomerLookup(activePhone, restaurant.restaurant_id);
  const {
    rewards,
    loading: rewardsLoading,
    refetch
  } = useAvailableRewards(activePhone, restaurant.restaurant_id);
  const {
    redeem,
    loading: redeeming
  } = useRedeemReward();
  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (phoneSearch.length >= 8) {
      setActivePhone(phoneSearch);
    }
  };
  const handleRedeem = async (rewardId: string) => {
    if (window.confirm('¿Estás seguro de redimir este beneficio? Esta acción no se puede deshacer.')) {
      const result = await redeem(rewardId);
      if (result.success) {
        alert('¡Beneficio redimido con éxito!');
        refetch(); // Refresh rewards list
      } else {
        alert('Error al redimir el beneficio: ' + result.error);
      }
    }
  };
  return <AdminLayout restaurant={restaurant} role={role} onSignOut={signOut} data-id="element-3945">
      <div className="p-6 max-w-3xl mx-auto space-y-6" data-id="element-3946">
        <div data-id="element-3947">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-3948">
            Redimir Beneficios
          </h1>
          <p className="text-gray-500" data-id="element-3949">
            Busca a un cliente por su número de teléfono para ver y redimir sus
            beneficios.
          </p>
        </div>

        <Card className="p-6" data-id="element-3950">
          <form onSubmit={handleSearch} className="flex gap-3" data-id="element-3951">
            <div className="flex-1" data-id="element-3952">
              <Input type="tel" placeholder="Número de teléfono (ej. 88888888)" value={phoneSearch} onChange={e => setPhoneSearch(e.target.value)} className="w-full" data-id="element-3953" />
            </div>
            <Button type="submit" disabled={phoneSearch.length < 8} data-id="element-3954">
              <Search className="w-4 h-4 mr-2" data-id="element-3955" />
              Buscar
            </Button>
          </form>
        </Card>

        {activePhone && <div className="space-y-6" data-id="element-3956">
            {customerLoading || rewardsLoading ? <div className="text-center py-12 text-gray-500" data-id="element-3957">
                Buscando información...
              </div> : !customer ? <Card className="p-12 text-center" data-id="element-3958">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-3959">
                  <Search className="w-8 h-8 text-gray-400" data-id="element-3960" />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-3961">
                  Cliente no encontrado
                </h3>
                <p className="text-gray-500" data-id="element-3962">
                  No hay ningún cliente registrado con el número {activePhone}.
                </p>
              </Card> : <>
                <Card className="p-6 bg-brand-charcoal text-white" data-id="element-3963">
                  <div className="flex items-center gap-4" data-id="element-3964">
                    <div className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center text-2xl font-bold" data-id="element-3965">
                      {customer.name ? customer.name.charAt(0).toUpperCase() : '?'}
                    </div>
                    <div data-id="element-3966">
                      <h2 className="text-xl font-bold" data-id="element-3967">
                        {customer.name || 'Cliente sin nombre'}
                      </h2>
                      <p className="text-white/70" data-id="element-3968">{customer.phone}</p>
                    </div>
                  </div>
                </Card>

                <div data-id="element-3969">
                  <h3 className="font-bold text-gray-900 mb-4 flex items-center gap-2" data-id="element-3970">
                    <Gift className="w-5 h-5 text-brand-charcoal" data-id="element-3971" />
                    Beneficios Disponibles ({rewards.length})
                  </h3>

                  {rewards.length === 0 ? <Card className="p-8 text-center text-gray-500" data-id="element-3972">
                      Este cliente no tiene beneficios disponibles en este
                      momento.
                    </Card> : <div className="grid gap-4" data-id="element-3973">
                      {rewards.map(reward => <Card key={reward.id} className="p-4 flex items-center justify-between gap-4 border-l-4 border-l-brand-charcoal" data-id="element-3974">
                          <div data-id="element-3975">
                            <h4 className="font-bold text-gray-900 text-lg" data-id="element-3976">
                              {reward.reward_name}
                            </h4>
                            <p className="text-sm text-gray-500" data-id="element-3977">
                              Válido hasta:{' '}
                              {new Date(reward.expires_at).toLocaleDateString()}
                            </p>
                          </div>
                          <Button onClick={() => handleRedeem(reward.id)} disabled={redeeming} data-id="element-3978">
                            Redimir
                          </Button>
                        </Card>)}
                    </div>}
                </div>
              </>}
          </div>}
      </div>
    </AdminLayout>;
}